import { ReactFlowJsonObject } from "reactflow";
import { Country } from "./Country";
import api from "./api";
import { Tool } from "./Tool";

export type tableSchema = {
    _id?: string,
    order: string,
    action: string,
    application: Tool | string,
    responsible: string,
    triggerStage: string,
    comments: string,
    flowInclude: boolean,
    duration: number,
    links?:{link:string, title:string}[];
};

export type tableDoDontSchema = {
    _id?: string,
    do: string,
    dont: string
}

export type childrenTitles = {
    title: string,
    children: string | Item
};

export type Item = {
    _id?: string;
    title: string;
    itemType: string;
    parent: boolean;
    content?: string;
    tableContent?: tableSchema[],
    titleDoDont?: string,
    tableDoDont?: tableDoDontSchema[]
    tablePlanning?: tableSchema[],
    tableBids?: tableSchema[],
    tableEvaluation?: tableSchema[],
    tableCommitteeReview?: tableSchema[],
    tableContractAward?: tableSchema[],
    tableContractManagement?: tableSchema[],
    children: childrenTitles[],
    country: Country | string;
}

export type SubTitle = {
    childeren: string;
    title: string;
    _id: string;
}

export type Title = {
    id: string;
    title: string;
    children: SubTitle[];
}


const URL = 'items/'
export const ItemService = {

    create: function (item: Item) {
        return api.post(URL, item);
    },
    update: function (item: Item) {
        return api.patch(URL + item._id + '/', item)
    },
    delete: function (itemId: string) {
        return api.delete(URL + itemId + '/')
    },
    getById: function (itemId: string, populate?: boolean) {
        return api.get(URL + itemId + '/?populate='+populate)
    },
    getAll: function (countryId: string) {
        return api.get(URL + 'all/?country='+ countryId)
    },
    getTitles: function (country: string) {
        return api.get(URL + 'titles/?country=' + country)
    },
    orderMenu: function (titles: Title[]) {
        return api.patch(URL + 'ordermenu/', titles)
    },
}
